import { render, staticRenderFns } from "./fileAttachment.vue?vue&type=template&id=c11966f4&"
import script from "./fileAttachment.vue?vue&type=script&lang=js&"
export * from "./fileAttachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c11966f4')) {
      api.createRecord('c11966f4', component.options)
    } else {
      api.reload('c11966f4', component.options)
    }
    module.hot.accept("./fileAttachment.vue?vue&type=template&id=c11966f4&", function () {
      api.rerender('c11966f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/Clearing/components/makeInvoice/fileAttachment.vue"
export default component.exports